import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    text: {
      color: 'rgba(255, 255, 255, 0.87)',
      fontWeight: 400,
    },
    firstAutoComplete: {
      marginTop: '8px',
      height: '44px',
    },
    container: {
      paddingLeft: '8px',
      paddingRight: '8px',
    },
    label: {
      fontWeight: 300,
      letterSpacing: '0.15px',
      marginTop: '20px',
      color: 'rgba(255, 255, 255, 0.87)',
    },
    popUpConfirmLabel: {
      fontWeight: 700,
      color: MaterialPalette.common.black,
    },
    noWPActionGrid: {
      padding: '8px 16px 8px 8px',
      '& .noWPLogoutButton': {
        width: '91px',
        height: '44px',
      },
    },
    siteDisciplineButtonGrid: {
      padding: '8px 16px 8px 8px',
      '& .confirmButton': {
        borderRadius: '4px',
        width: '91px',
        height: '44px',
      },
      '& .confirmButtonDisabled': {
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        borderRadius: '4px',
        width: '91px',
        height: '44px',
      },
    },
    sdSubHeading: {
      marginTop: '20px',
    },
    siteSlectionGrid: {
      padding: '0px',
      marginBottom: '20px',
    },
    circularProgressGrid: {
      textAlign: 'center',
    },
    noAssignedWPMessagGrid: {
      padding: '0px',
      marginBottom: '23px',
      marginTop: '31px',
    },
  }),
);

export default useStyles;
